import { ReduxAction } from '../core';
import { ToastParams } from './types';

export class MessageActions {
  public static TOAST_MESSAGE = `MESSAGE_TOAST`;
}

export function toast(value: ToastParams): ReduxAction<ToastParams> {
  return {
    type: MessageActions.TOAST_MESSAGE,
    data: value,
  };
}
